import { Button, Grid, Tooltip, Typography } from "@mui/material";
import { Link, number } from "react-admin";
import CustomArrowCircleLeftSharpIcon from "../../unit/CustomArrowCircleLeftSharpIcon";

const LoanActionsBackToList = ({ ...props }) => {
  //  transferFatalErrorNumber={record?.loan?.transferFatalErrorNumber}
  //           transferFailedNumber={record?.loan?.transferFailedNumber}
  //           insufficientBalanceCheckNumber={
  //             record?.loan?.insufficientBalanceCheckNumber
  // }

  const {
    loanStatus,
    curStatus,
    creditBalance,
    modify_num,
    maturityDate,
    transferFatalErrorNumber,
    transferFailedNumber,
    insufficientBalanceCheckNumber,
    smartach,
  } = props;

  const getRemainingTermFilter = (loanMaturityDate: any) => {
    if (!loanMaturityDate) {
      return "<12 Months";
    }

    const maturity = new Date(loanMaturityDate);

    if (Number.isNaN(maturity.getTime())) {
      return "<12 Months";
    }

    const now = new Date();
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const remainingDays = Math.floor(
      (maturity.getTime() - now.getTime()) / millisecondsPerDay
    );

    if (remainingDays >= 1825) {
      return ">60 Months";
    }
    if (remainingDays >= 1460) {
      return "48-60 Months";
    }
    if (remainingDays >= 1095) {
      return "36-48 Months";
    }
    if (remainingDays >= 730) {
      return "24-36 Months";
    }
    if (remainingDays >= 365) {
      return "12-24 Months";
    }

    return "<12 Months";
  };

  const remainingTermFilter = getRemainingTermFilter(maturityDate);
  const defaultActiveBackLink = `/loans?filter={"status":"active","curStatus":"OK","filterRemainingterm":"${remainingTermFilter}"}`;

  let backLink =
    '/loans?filter={"status":"active","curStatus":"OK","filterRemainingterm":"<12 Months"}';
  if (loanStatus == "Voided") {
    backLink = '/loans?filter={"status":"Voided"}';
  } else if (loanStatus == "Charged-Off") {
    backLink = '/loans?filter={"status":"Charged-Off"}';
  } else if (loanStatus == "Paid-Off") {
    if (Number(creditBalance) < 0) {
      backLink =
        '/loans?filter={"status":"Paid-Off","curStatus":"creditBalance"}';
    } else {
      backLink = '/loans?filter={"status":"Paid-Off"}';
    }
  } else {
    // backLink =
    //   localStorage.getItem("backUrl-" + props.appId + "-" + props.loannum) ||
    //   '/loans?filter={"status":"active","curStatus":"OK","filterRemainingterm":"<12 Months"}';
    if (localStorage.getItem("backUrl-" + props.appId + "-" + props.loannum)) {
      backLink = localStorage.getItem(
        "backUrl-" + props.appId + "-" + props.loannum
      ) as string;
    } else {
      if (curStatus == "Active") {
        // if (modify_num > 6) {
        //   backLink = '/loans?filter={"status":"active","curStatus":"OK6"}';
        // } else if (modify_num >= 3 && modify_num <= 6) {
        if (modify_num >= 3) {
          backLink = '/loans?filter={"status":"active","curStatus":"OK36"}';
        } else if (modify_num > 0 && modify_num < 3) {
          backLink = '/loans?filter={"status":"active","curStatus":"OK3"}';
        } else {
          backLink = defaultActiveBackLink;
        }
      } else if (
        curStatus == "30D" ||
        curStatus == "60D" ||
        curStatus == "90D"
      ) {
        backLink = `/loans?filter={"status":"active","curStatus":"large30D"}`;
      } else if (curStatus == "Late") {
        backLink = `/loans?filter={"status":"active","curStatus":"Late"}`;
      } else {
        if (
          smartach === true &&
          maturityDate &&
          new Date(maturityDate) <=
            new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)
        ) {
          backLink = `/loans?filter={"status":"active","curStatus":"delinquentPastMaturity"}`;
        }

        if (transferFatalErrorNumber >= 1) {
          backLink = `/loans?filter={"status":"active","curStatus":"Funding Source Removed"}`;
        }
        if (transferFailedNumber >= 2) {
          backLink = `/loans?filter={"status":"active","curStatus":"Transfer Failed"}`;
        }
        if (insufficientBalanceCheckNumber >= 2) {
          backLink = `/loans?filter={"status":"active","curStatus":"Insufficient Balance"}`;
        }
      }
    }
  }
  return (
    <Tooltip title="Return to Loan Lists" placement="left">
      <span className="app-back-link">
        <Link to={backLink}>
          <CustomArrowCircleLeftSharpIcon />
        </Link>
      </span>
    </Tooltip>
  );
};

export default LoanActionsBackToList;
